<template>
  <div class="row justify-content-center align-items-center">
    <div class="col-sm-12 col-md-3">
      <div class="dataTables_info text-start fs-small">
        Total {{ pagination.total }} results found
      </div>
    </div>
    <div class="col-sm-12 col-md-9">
      <div class="dataTables_paginate align-item-end">
        <paginate
          :value="pagenum"
          :page-count="pagination.pageCount"
          :click-handler="pageNavigate"
          prev-text="<img src='/vstatic/munna/assets/images/icons/arrow-long-left.svg' alt='arrow left'>"
          next-text="<img src='/vstatic/munna/assets/images/icons/arrow-long-right.svg' alt='arrow right'>"
          :container-class="'pagination justify-content-end'"
          :pageClass="'page-item'"
          :pageLinkClass="'page-link'"
          :activeClass="'active'"
          :disabledClass="'disabled'"
          :prevClass="'page-item previous'"
          :prevLinkClass="'page-link'"
          :nextClass="'page-item next'"
          :nextLinkClass="'page-link'"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
export default {
  components: { Paginate },
  props: {
    pagination: {
    },
    pagenum: {
    },
    setQueryParam: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    pageNavigate(page) {
      // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#change_a_query_parameter
      // const url = new URL(window.location);
      // url.searchParams.set("page", page);
      // window.history.pushState({}, "", url);
      if(this.setQueryParam){
        this.setPageQueryParam(page)
      }

      this.$emit("handler", page);
    },
  },
};
</script>